import { createFileRoute } from '@tanstack/react-router';
import Users from '@/features/users';
import { ProtectedRoute } from '@/components/auth/protected-route';
import { Permissions } from '@/constants/roles-permissions';

export const Route = createFileRoute('/_authenticated/users')({
  component: UsersRoute,
});

function UsersRoute() {
  return (
    <ProtectedRoute requiredPermission={Permissions.UserView}>
      <Users />
    </ProtectedRoute>
  );
} 